import React from "react";
import { FiAward } from "react-icons/fi";

export default function StatsSection() {
  const stats = [
    {
      number: "15+",
      label: "Years of Experience",
    },
    {
      number: "150+",
      label: "Completed Projects",
    },
    {
      number: "100%",
      label: "Client Satisfaction",
    },
    {
      number: <FiAward className="text-2xl md:text-3xl" />,
      label: "Licensed & Insured",
    },
  ];

  return (
    <section className="py-6 md:py-8 px-4 md:px-6 -mt-4">
      <div className="max-w-4xl mx-auto">
        {/* DARK BACKGROUND CONTAINER */}
        <div className="bg-[#343a40] rounded-2xl shadow-lg px-4 py-6 md:px-6 md:py-8">
          <div className="flex flex-col lg:flex-row items-center gap-4">

            {/* LEFT TEXT */}
            <div className="lg:w-[28%] text-center flex flex-col items-center">
              <p className="text-[#dee2e6] text-base font-medium whitespace-nowrap">
                Built on trust, proven by
              </p>
              <p className="text-xl md:text-2xl font-bold text-[#f8f9fa] whitespace-nowrap">
                Real Results
              </p>
            </div>

            {/* DIVIDER */}
            <div className="hidden lg:block w-px h-14 bg-[#495057]"></div>

            {/* STATS */}
            <div className="flex-1 grid grid-cols-2 md:grid-cols-4 gap-4">
              {stats.map((stat, idx) => (
                <div
                  key={idx}
                  className="flex flex-col items-center text-center transition-transform duration-300 hover:scale-105"
                >
                  {/* NUMBER / ICON */}
                  <div className="h-8 md:h-10 flex items-center justify-center mb-1">
                    <span className="text-xl md:text-2xl font-bold text-[#f8f9fa] flex items-center">
                      {stat.number}
                    </span>
                  </div>

                  {/* LABEL */}
                  <p className="text-xs md:text-sm text-[#dee2e6] font-medium">
                    {stat.label}
                  </p>
                </div>
              ))}
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}